export default {
	namespaced: true,
	state: {
		themes: [
			'info', 'success', 'warning', 'danger', 'primary', 'default', 'secondary',
			'gradient-info', 'gradient-success', 'gradient-warning', 'gradient-danger', 'gradient-primary',
			'gradient-default', 'gradient-secondary',
		],
		textStyleColors: {
			'info': '#E6E6E6',
			'success': '#E6E6E6',
			'warning': '#000cff',
			'danger': '#E6E6E6',
			'primary': '#E6E6E6',
			'default': '#55aaff',
			'secondary': '#ffffff',
			'gradient-info': '#E6E6E6',
			'gradient-success': '#E6E6E6',
			'gradient-warning': '#000cff',
			'gradient-danger': '#E6E6E6',
			'gradient-primary': '#E6E6E6',
			'gradient-default': '#55aaff',
			'gradient-secondary': '#E6E6E6',
		}
	},
	getters: {
		themes(state) {
			return state.themes.sort(function() {
				return .8 - Math.random();
			})
		},
		textStyleColors(state) {
			return state.textStyleColors
		},
		all_themes(state) {
			return state.themes
		}
	}
}
